import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import styles from './CadastroImoveis.module.css';
import { FaLandmark, FaTree, FaClipboardList, FaFileContract, FaPercent } from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { API_BASE_URL } from "../../../../config";
import PageHeader from '../../../../components/PageHeader/PageHeader';
import LoadingOverlay from '../../../../components/LoadingOverlay/LoadingOverlay';

const CadastroImoveis = () => {
    const initialState = {
        descricao: '', codigo_cc: '', area_imovel: '', area_plantio: '',
        especie: '', origem: '', num_arvores_plantadas: '', num_arvores_cortadas: '',
        matricula: '', data_plantio: '', data_contrato: '', vencimento_contrato: '',
        numero_ccir: '', numero_itr: '', proprietario: '', arrendatario: '',
        municipio: '', localidade: '', numero_car: '', percentual_arrendatario: '',
        percentual_arrendadores: '', area_plantio_arrendatario: '', area_plantio_arrendadores: '',
        data_divisao_percentual: '',
    };

    const [formData, setFormData] = useState(initialState);
    const [isArrendado, setIsArrendado] = useState(false);
    const [errors, setErrors] = useState({});
    const [pageLoading, setPageLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            setPageLoading(false);
        }, 300); 

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!isArrendado) return;

        const areaPlantioNum = parseFloat(String(formData.area_plantio).replace(',', '.')) || 0;
        const percArrendatarioNum = parseFloat(String(formData.percentual_arrendatario).replace(',', '.')) || 0;

        if (percArrendatarioNum >= 0 && percArrendatarioNum <= 100) {
            const percArrendadores = 100 - percArrendatarioNum;
            const areaArrendatario = areaPlantioNum * (percArrendatarioNum / 100);
            const areaArrendadores = areaPlantioNum * percArrendadores / 100;

            setFormData(prev => ({
                ...prev,
                percentual_arrendadores: percArrendadores.toFixed(2).replace('.', ','),
                area_plantio_arrendatario: areaArrendatario.toFixed(2).replace('.', ','),
                area_plantio_arrendadores: areaArrendadores.toFixed(2).replace('.', ','),
            }));
        }
    }, [formData.area_plantio, formData.percentual_arrendatario, isArrendado]);

    const validateField = async (name, value) => {
        const baseRequiredFields = ['descricao', 'codigo_cc', 'numero_car', 'area_imovel', 'area_plantio', 'especie', 'origem', 'num_arvores_plantadas', 'num_arvores_cortadas', 'matricula', 'data_plantio', 'numero_ccir', 'numero_itr', 'proprietario', 'municipio', 'localidade'];
        const arrendadoRequiredFields = ['vencimento_contrato', 'arrendatario', 'data_contrato', 'percentual_arrendatario', 'data_divisao_percentual'];
        const requiredFields = isArrendado ? [...baseRequiredFields, ...arrendadoRequiredFields] : baseRequiredFields;

        if (requiredFields.includes(name) && (!value || String(value).trim() === '')) {
            return 'Campo obrigatório.';
        }
        
        if (name === 'codigo_cc') {
            const exists = await checkCodigoCCExists(value);
            if (exists) {
                return 'Este Código CC já está cadastrado.';
            }
        }
        return ''; 
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
        if (errors[id]) {
            setErrors(prev => ({ ...prev, [id]: '' }));
        }
    };

    const handleBlur = async (e) => {
        const { id, value } = e.target;
        const error = await validateField(id, value);
        setErrors(prev => ({ ...prev, [id]: error }));
    };

    const checkCodigoCCExists = async (codigo_cc) => {
        if (!codigo_cc) return false;
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_BASE_URL}/api/verificarCodigoCC?codigo_cc=${codigo_cc}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) return false;
            const data = await response.json();
            return data.exists;
        } catch (error) {
            console.error("Erro ao verificar o código CC:", error);
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) {
            Swal.fire('Sessão Expirada', 'Por favor, faça login novamente.', 'warning');
            navigate('/');
            return;
        }

        const newErrors = {};
        const fieldsToValidate = ['descricao', 'codigo_cc', 'numero_car', 'area_imovel', 'area_plantio', 'especie', 'origem', 'num_arvores_plantadas', 'num_arvores_cortadas', 'matricula', 'data_plantio', 'numero_ccir', 'numero_itr', 'proprietario', 'municipio', 'localidade'];
        if (isArrendado) {
            fieldsToValidate.push('vencimento_contrato', 'arrendatario', 'data_contrato', 'percentual_arrendatario', 'data_divisao_percentual');
        }

        for (const field of fieldsToValidate) {
            const error = await validateField(field, formData[field]);
            if (error) newErrors[field] = error;
        }

        if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    Swal.fire({
        title: 'Campos Inválidos',
        text: 'Por favor, corrija os campos destacados em vermelho.',
        icon: 'error',
        confirmButtonColor: '#28a745' 
    });
    return;
}
        const parseToFloat = (value) => parseFloat(String(value).replace(',', '.')) || 0;
        const num_arvores_plantadas = parseToFloat(formData.num_arvores_plantadas);
        const num_arvores_cortadas = parseToFloat(formData.num_arvores_cortadas);
        const area_plantio = parseToFloat(formData.area_plantio);
        const num_arvores_remanescentes = num_arvores_plantadas - num_arvores_cortadas;
        const num_arvores_por_hectare = area_plantio > 0 ? num_arvores_remanescentes / area_plantio : 0;

        const formDataToSend = {
            ...formData,
            num_arvores_remanescentes,
            num_arvores_por_hectare: num_arvores_por_hectare.toFixed(2),
            altura_desrama: 0,
            arrendatario: isArrendado ? formData.arrendatario : null,
            vencimento_contrato: isArrendado ? formData.vencimento_contrato : null,
            data_contrato: isArrendado ? formData.data_contrato : null,
            percentual_arrendatario: isArrendado ? parseToFloat(formData.percentual_arrendatario) : null,
            percentual_arrendadores: isArrendado ? parseToFloat(formData.percentual_arrendadores) : null,
            area_plantio_arrendatario: isArrendado ? parseToFloat(formData.area_plantio_arrendatario) : null,
            area_plantio_arrendadores: isArrendado ? parseToFloat(formData.area_plantio_arrendadores) : null,
            data_divisao_percentual: isArrendado ? formData.data_divisao_percentual : null,
        };

        try {
            const response = await fetch(`${API_BASE_URL}/api/imoveis`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formDataToSend),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: 'Erro desconhecido.' }));
                throw new Error(errorData.error || `Erro ${response.status}`);
            }

            Swal.fire({ icon: 'success', title: 'Sucesso!', text: 'Imóvel cadastrado com sucesso!', confirmButtonColor: '#28a745' });
            setFormData(initialState);
            setIsArrendado(false);
            setErrors({});

        } catch (error) {
            Swal.fire('Erro!', error.message || 'Não foi possível se comunicar com o servidor.', 'error');
        }
    };
    
    const toggleTipoImovel = (tipo) => {
        const isNowArrendado = tipo === 'arrendado';
        setIsArrendado(isNowArrendado);
        setErrors({});

        if (!isNowArrendado) {
            const { arrendatario, data_contrato, vencimento_contrato, ...rest } = initialState;
            setFormData(prev => ({
                ...prev,
                arrendatario: '', data_contrato: '', vencimento_contrato: '',
                percentual_arrendatario: '', percentual_arrendadores: '',
                area_plantio_arrendatario: '', area_plantio_arrendadores: '',
                data_divisao_percentual: '',
            }));
        }
    };
    
    const getInputClassName = (fieldName) => `${styles.formInput} ${errors[fieldName] ? styles.errorInput : ''}`;

    return (
        <div className={styles.pageContainer}>
            {pageLoading && <LoadingOverlay text="Carregando..." />}

            {!pageLoading && (
                <>
                    <PageHeader 
                        title="Cadastro de Imóvel" 
                        subtitle="Preencha os dados para registrar um novo imóvel."
                        backTo="/sistema-imoveis"
                    />

                    <form className={styles.formCard} onSubmit={handleSubmit} noValidate>
                        <div className={styles.formSection}>
                            <h2 className={styles.formSectionTitle}><FaFileContract /> Tipo de Posse</h2>
                            <div className={styles.segmentedControl}>
                                <div className={`${styles.slider} ${isArrendado ? styles.arrendado : ''}`}></div>
                                <button type="button" className={!isArrendado ? styles.active : ''} onClick={() => toggleTipoImovel('proprio')}>Próprio</button>
                                <button type="button" className={isArrendado ? styles.active : ''} onClick={() => toggleTipoImovel('arrendado')}>Arrendado</button>
                            </div>
                        </div>
                        
                        <div className={styles.formSection}>
                            <h2 className={styles.formSectionTitle}><FaLandmark /> Identificação do Imóvel</h2>
                            <div className={styles.formGrid}>
                                <div className={`${styles.inputGroup} ${styles.fullWidth}`}>
                                    <label htmlFor="descricao" className={styles.formLabel}>Descrição</label>
                                    <input type="text" id="descricao" value={formData.descricao} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('descricao')} />
                                    <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.descricao}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                    <label htmlFor="codigo_cc" className={styles.formLabel}>Código CC</label>
                                    <input type="text" id="codigo_cc" value={formData.codigo_cc} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('codigo_cc')} />
                                    <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.codigo_cc}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                    <label htmlFor="matricula" className={styles.formLabel}>Matrícula</label>
                                    <input type="text" id="matricula" value={formData.matricula} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('matricula')} />
                                    <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.matricula}</span></div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.formSection}>
                            <h2 className={styles.formSectionTitle}><FaTree /> Áreas e Plantio</h2>
                            <div className={styles.formGrid}>
                                <div className={styles.inputGroup}>
                                        <label htmlFor="area_imovel" className={styles.formLabel}>Área do Imóvel (ha)</label>
                                        <input type="number" step="0.01" id="area_imovel" value={formData.area_imovel} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('area_imovel')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.area_imovel}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                        <label htmlFor="area_plantio" className={styles.formLabel}>Área de Plantio (ha)</label>
                                        <input type="number" step="0.01" id="area_plantio" value={formData.area_plantio} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('area_plantio')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.area_plantio}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                        <label htmlFor="especie" className={styles.formLabel}>Espécie</label>
                                        <input type="text" id="especie" value={formData.especie} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('especie')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.especie}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                        <label htmlFor="origem" className={styles.formLabel}>Origem</label>
                                        <input type="text" id="origem" value={formData.origem} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('origem')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.origem}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                        <label htmlFor="num_arvores_plantadas" className={styles.formLabel}>Nº de Árvores Plantadas</label>
                                        <input type="number" id="num_arvores_plantadas" value={formData.num_arvores_plantadas} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('num_arvores_plantadas')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.num_arvores_plantadas}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                        <label htmlFor="num_arvores_cortadas" className={styles.formLabel}>Nº de Árvores Cortadas</label>
                                        <input type="number" id="num_arvores_cortadas" value={formData.num_arvores_cortadas} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('num_arvores_cortadas')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.num_arvores_cortadas}</span></div>
                                </div>
                                <div className={styles.inputGroup}>
                                    <label htmlFor="data_plantio" className={styles.formLabel}>Data de Plantio</label>
                                    <input type="date" id="data_plantio" value={formData.data_plantio} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('data_plantio')} />
                                    <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.data_plantio}</span></div>
                                </div>
                            </div>
                        </div>
                        
                        <div className={`${styles.arrendadoSection} ${isArrendado ? styles.visible : ''}`}>
                            <div className={styles.formSection}>
                                <h2 className={styles.formSectionTitle}><FaFileContract /> Dados do Contrato</h2>
                                <div className={styles.formGrid}>
                                    <div className={styles.inputGroup}>
                                            <label htmlFor="arrendatario" className={styles.formLabel}>Arrendatário</label>
                                            <input type="text" id="arrendatario" value={formData.arrendatario} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('arrendatario')} />
                                            <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.arrendatario}</span></div>
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label htmlFor="data_contrato" className={styles.formLabel}>Data do Contrato</label>
                                        <input type="date" id="data_contrato" value={formData.data_contrato} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('data_contrato')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.data_contrato}</span></div>
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label htmlFor="vencimento_contrato" className={styles.formLabel}>Vencimento do Contrato</label>
                                        <input type="date" id="vencimento_contrato" value={formData.vencimento_contrato} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('vencimento_contrato')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.vencimento_contrato}</span></div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.formSection}>
                                <h2 className={styles.formSectionTitle}><FaPercent /> Divisão de Percentuais e Áreas</h2>
                                <div className={styles.formGrid}>
                                    <div className={styles.inputGroup}>
                                            <label htmlFor="percentual_arrendatario" className={styles.formLabel}>Percentual Arrendatário (%)</label>
                                            <input type="number" step="0.01" min="0" max="100" id="percentual_arrendatario" value={formData.percentual_arrendatario} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('percentual_arrendatario')} />
                                            <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.percentual_arrendatario}</span></div>
                                    </div>
                                    <div className={styles.inputGroup}>
                                            <label htmlFor="percentual_arrendadores" className={styles.formLabel}>Percentual Arrendadores (%)</label>
                                            <input type="text" className={styles.formInput} id="percentual_arrendadores" value={formData.percentual_arrendadores} disabled />
                                    </div>
                                    <div className={styles.inputGroup}>
                                            <label htmlFor="area_plantio_arrendatario" className={styles.formLabel}>Área Plantio Arrendatário (ha)</label>
                                            <input type="text" className={styles.formInput} id="area_plantio_arrendatario" value={formData.area_plantio_arrendatario} disabled />
                                    </div>
                                    <div className={styles.inputGroup}>
                                            <label htmlFor="area_plantio_arrendadores" className={styles.formLabel}>Área Plantio Arrendadores (ha)</label>
                                            <input type="text" className={styles.formInput} id="area_plantio_arrendadores" value={formData.area_plantio_arrendadores} disabled />
                                    </div>
                                    <div className={`${styles.inputGroup} ${styles.fullWidth}`}>
                                        <label htmlFor="data_divisao_percentual" className={styles.formLabel}>Data da Divisão</label>
                                        <input type="date" id="data_divisao_percentual" value={formData.data_divisao_percentual} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('data_divisao_percentual')} />
                                        <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.data_divisao_percentual}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.formSection}>
                                <h2 className={styles.formSectionTitle}><FaClipboardList /> Dados Legais e Fiscais</h2>
                                <div className={styles.formGrid}>
                                        <div className={styles.inputGroup}>
                                                <label htmlFor="numero_car" className={styles.formLabel}>Número CAR</label>
                                                <input type="text" id="numero_car" value={formData.numero_car} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('numero_car')} />
                                                <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.numero_car}</span></div>
                                        </div>
                                        <div className={styles.inputGroup}>
                                                <label htmlFor="numero_ccir" className={styles.formLabel}>Número do CCIR</label>
                                                <input type="text" id="numero_ccir" value={formData.numero_ccir} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('numero_ccir')} />
                                                <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.numero_ccir}</span></div>
                                        </div>
                                        <div className={styles.inputGroup}>
                                                <label htmlFor="numero_itr" className={styles.formLabel}>Número do ITR</label>
                                                <input type="text" id="numero_itr" value={formData.numero_itr} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('numero_itr')} />
                                                <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.numero_itr}</span></div>
                                        </div>
                                        <div className={styles.inputGroup}>
                                                <label htmlFor="proprietario" className={styles.formLabel}>Proprietário</label>
                                                <input type="text" id="proprietario" value={formData.proprietario} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('proprietario')} />
                                                <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.proprietario}</span></div>
                                        </div>
                                        <div className={styles.inputGroup}>
                                                <label htmlFor="municipio" className={styles.formLabel}>Município</label>
                                                <input type="text" id="municipio" value={formData.municipio} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('municipio')} />
                                                <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.municipio}</span></div>
                                        </div>
                                        <div className={styles.inputGroup}>
                                                <label htmlFor="localidade" className={styles.formLabel}>Localidade</label>
                                                <input type="text" id="localidade" value={formData.localidade} onChange={handleChange} onBlur={handleBlur} className={getInputClassName('localidade')} />
                                                <div className={styles.messageContainer}><span className={styles.errorMessage}>{errors.localidade}</span></div>
                                        </div>
                                </div>
                        </div>

                        <div className={styles.formFooter}>
                            <button type="submit" className={styles.submitButton}>Cadastrar Imóvel</button>
                        </div>
                    </form>
                </>
            )}
        </div>
    );
};

export default CadastroImoveis;